import { render, staticRenderFns } from "./RegisteredPhds.vue?vue&type=template&id=1d3a3708&"
import script from "./RegisteredPhds.vue?vue&type=script&lang=js&"
export * from "./RegisteredPhds.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredPhds.vue?vue&type=style&index=0&id=1d3a3708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports